import React from 'react';
import { SparklesIcon, StarIcon, BookOpenIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
export const StoryIdeasTips = () => {
  return <>
      <SEOHead title="Story Ideas & Tips - Story Bunny" description="Learn how to write great story ideas for Story Bunny. Simple formulas, examples, and tips to create magical stories for children." canonical="https://storybunny.ai/story-ideas-tips" data-id="element-1427" />
      <div className="min-h-screen bg-[#FFFBF6]" data-id="element-1428">
        <div className="max-w-4xl mx-auto px-4 py-12 space-y-16" data-id="element-1429">
          {/* Header */}
          <div className="text-center" data-id="element-1430">
            <h1 className="text-3xl md:text-4xl font-bold text-[#6B4B3E] mb-4" data-id="element-1431">
              Story Ideas & Tips
            </h1>
            <p className="text-lg text-[#6B4B3E]/80" data-id="element-1432">
              Learn how to write magical stories with Story Bunny
            </p>
          </div>
          {/* What's a Story Idea? */}
          <div className="bg-white rounded-2xl p-8 shadow-sm" data-id="element-1433">
            <h2 className="text-2xl font-bold text-[#6B4B3E] mb-4 flex items-center" data-id="element-1434">
              <SparklesIcon className="mr-2 text-[#D4A088]" data-id="element-1435" />
              What's a Story Idea?
            </h2>
            <p className="text-[#6B4B3E]/80 text-lg" data-id="element-1436">
              A story idea (also called a prompt) is just a sentence or two that
              tells Story Bunny who the story is about, what they love, and
              what's happening.
            </p>
          </div>
          {/* Simple Formula */}
          <div className="bg-[#FFF0E6] rounded-2xl p-8" data-id="element-1437">
            <h2 className="text-2xl font-bold text-[#6B4B3E] mb-4" data-id="element-1438">
              Try This Simple Formula
            </h2>
            <div className="bg-white rounded-xl p-6 text-[#6B4B3E] text-lg" data-id="element-1439">
              "[Name] is a [bunny, dragon, puppy, or child] who loves [something
              fun]. One day, they are [doing something fun] at [a place or
              setting]."
            </div>
          </div>
          {/* Examples */}
          <div className="bg-white rounded-2xl p-8 shadow-sm" data-id="element-1440">
            <h2 className="text-2xl font-bold text-[#6B4B3E] mb-6" data-id="element-1441">Examples</h2>
            <div className="space-y-4" data-id="element-1442">
              {["Emma is a bunny who loves balloons. She's planning a party in the backyard.", "Luna is a dragon who loves rainbows. She's flying through a castle made of clouds.", 'Max is a puppy who wants to fly. He finds a magical kite at the park.'].map((example, index) => <div key={index} className="bg-[#FFFBF6] rounded-xl p-6 text-[#6B4B3E]" data-id="element-1443">
                  {example}
                </div>)}
            </div>
          </div>
          {/* Tips */}
          <div className="bg-[#FFF0E6] rounded-2xl p-8" data-id="element-1444">
            <h2 className="text-2xl font-bold text-[#6B4B3E] mb-6" data-id="element-1445">
              Tips for Great Story Ideas
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1446">
              {['Keep it short — 1–2 sentences', 'One idea at a time', "Don't worry about grammar", 'Add a toy, feeling, or magical twist'].map((tip, index) => <div key={index} className="bg-white rounded-xl p-6 text-[#6B4B3E] flex items-center" data-id="element-1447">
                  <StarIcon className="mr-3 text-[#D4A088]" size={20} data-id="element-1448" />
                  {tip}
                </div>)}
            </div>
          </div>
          {/* Starter Prompts */}
          <div className="bg-white rounded-2xl p-8 shadow-sm" data-id="element-1449">
            <h2 className="text-2xl font-bold text-[#6B4B3E] mb-6" data-id="element-1450">
              Starter Prompts
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1451">
              {['A bunny who finds a magic leaf', "A dragon who doesn't want to go to sleep", 'A puppy who meets a new sibling', "A little girl who's scared of the dark", 'A boy who builds a rocket out of cardboard'].map((prompt, index) => <div key={index} className="bg-[#FFFBF6] rounded-xl p-6 text-[#6B4B3E]" data-id="element-1452">
                  {prompt}
                </div>)}
            </div>
          </div>
          {/* For Parents */}
          <div className="bg-[#FFF0E6] rounded-2xl p-8" data-id="element-1453">
            <h2 className="text-2xl font-bold text-[#6B4B3E] mb-6" data-id="element-1454">
              For Parents
            </h2>
            <p className="text-[#6B4B3E]/80 mb-6" data-id="element-1455">
              Story Bunny stories are always warm and safe. You can gently
              include themes like:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1456">
              {['Starting school', 'Saying goodbye to a pacifier', 'Getting a sibling', 'Being brave'].map((theme, index) => <div key={index} className="bg-white rounded-xl p-6 text-[#6B4B3E] flex items-center" data-id="element-1457">
                  <StarIcon className="mr-3 text-[#D4A088]" size={20} data-id="element-1458" />
                  {theme}
                </div>)}
            </div>
          </div>
          {/* CTA */}
          <div className="text-center pt-8" data-id="element-1459">
            <Link to="/" className="inline-flex items-center px-8 py-4 bg-[#D4A088] text-white rounded-full text-xl font-medium hover:bg-[#C28B73] transition-colors" data-id="element-1460">
              <BookOpenIcon className="mr-2" size={24} data-id="element-1461" />
              Let's Make a Story →
            </Link>
          </div>
        </div>
      </div>
    </>;
};